import { createFeatureSelector, createSelector } from '@ngrx/store';
import { TipoContratoState } from './tipo-contrato.state';
import { TipoContrato } from '../models/tipo-contrato.interface';

export const selectTipoContratoState = createFeatureSelector<TipoContratoState>('tipoContrato');

export const selectAllTiposContrato = createSelector(
  selectTipoContratoState,
  (state: TipoContratoState) => state.tiposContrato
);

export const selectSelectedTipoContrato = createSelector(
  selectTipoContratoState,
  (state: TipoContratoState) => state.selectedTipoContrato
);

export const selectTipoContratoLoading = createSelector(
  selectTipoContratoState,
  (state: TipoContratoState) => state.loading
);

export const selectTipoContratoError = createSelector(
  selectTipoContratoState,
  (state: TipoContratoState) => state.error
);

export const selectTipoContratoCreating = createSelector(
  selectTipoContratoState,
  (state: TipoContratoState) => state.creating
);

export const selectTipoContratoUpdating = createSelector(
  selectTipoContratoState,
  (state: TipoContratoState) => state.updating
);

export const selectTipoContratoDeleting = createSelector(
  selectTipoContratoState,
  (state: TipoContratoState) => state.deleting
);

export const selectTipoContratoSearchResults = createSelector(
  selectTipoContratoState,
  (state: TipoContratoState) => state.searchResults
);

export const selectTipoContratoSearchQuery = createSelector(
  selectTipoContratoState,
  (state: TipoContratoState) => state.searchQuery
);

export const selectTipoContratoById = createSelector(
  selectAllTiposContrato,
  (tiposContrato: TipoContrato[], id: number) => tiposContrato.find(tc => tc.tipoContratoId === id)
);

export const selectTiposContratoCount = createSelector(
  selectAllTiposContrato,
  (tiposContrato: TipoContrato[]) => tiposContrato.length
);
